import React, { useState } from 'react';
import { documentTypeServices } from '../../../APIServices/documentTypeServices';
import { useToast } from '../../../hooks/useToast';

function AddNewDocumentType({ getDocumentTypeData, setModalOpen }) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [documentType, setDocumentType] = useState('');

  const addNewDocumentType = async () => {
    setButtonLoader(true);
    try {
      const data = await documentTypeServices.addNewDocumentType({ documentType });
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Document type added successfully.', 'ok');
        setDocumentType('');
        getDocumentTypeData();
        setModalOpen('');
      } else {
        toast(data?.customMessage || 'Unable to add document type.', 'warn');
      }
    } catch (error) {
      toast('Unable to add document type. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={() => setModalOpen('')}>
      <div className="modal" style={{ maxWidth: 480 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div>
            <div className="modal-title">Add Document Type</div>
            <div className="xs muted">Create a new document type for workspace metadata</div>
          </div>
          <button className="icon-btn" onClick={() => setModalOpen('')}>
            <i className="ti ti-x" />
          </button>
        </div>

        <div className="modal-body">
          <div className="field">
            <label className="field-label">
              Document Type Name
              <span className="req">*</span>
            </label>
            <input
              className="inp"
              autoFocus
              disabled={buttonLoader}
              placeholder="e.g., Protocol, CRF, SAP"
              value={documentType}
              onChange={(e) => setDocumentType(e.target.value)}
            />
          </div>
        </div>

        <div className="modal-foot">
          <button className="btn btn-ghost" onClick={() => setModalOpen('')}>Cancel</button>
          <button
            className="btn btn-primary d-flex align-items-center justify-content-center gap-2"
            onClick={addNewDocumentType}
            disabled={buttonLoader || !documentType}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Adding...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Add Document Type</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddNewDocumentType;
